import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedDate } from 'react-intl';
import get from 'lodash/get';
import Grid from '../../components/Grid';
import Avatar from '../../components/Avatar';
import getCommunityPersonPhone from '../../utils/community';

import './styles.css';
import messages from './messages';

export const DATE_FORMAT = {
  year: 'numeric',
  day: '2-digit',
  month: 'short',
  weekday: 'long',
};

class CollegeFairDetails extends React.PureComponent {
  static propTypes = {
    node: PropTypes.object.isRequired,
    contact: PropTypes.object,
  };

  render() {
    const { node, contact } = this.props;
    const eventDetails = {
      contact: get(node, 'highSchool.repVisitsAccount.collegeFairsPrimaryContact'),
      phone: get(node, 'highSchool.repVisitsAccount.collegeFairsPrimaryContactPhone'),
      schoolName: get(node, 'highSchool.name'),
      fairName: node.name,
      startTime: node.startTime,
      endTime: node.endTime,
      date: node.date,
      webInstructions: node.webInstructions,
    };

    if (contact) {
      eventDetails.contact = contact;
      eventDetails.phone = contact.field_phone;
    }

    return (
      <div styleName="container">
        <h1 styleName="title">{eventDetails.fairName}</h1>
        <h3><FormattedMessage {...messages.contactDetails} /></h3>
        <Grid>
          {eventDetails.contact && (
          <Grid.Row styleName="no-bottom-padding">
            <Grid.Column width={16}>
              <h4><FormattedMessage {...messages.representative} /></h4>
            </Grid.Column>
          </Grid.Row>
          )}
          {eventDetails.contact && (
          <Grid.Row verticalAlign="middle" styleName="no-top-padding">
            <Grid.Column width={3}>
              <Avatar
                big
                icon="user"
                image={eventDetails.contact.field_profile_picture_file_url}
              />
            </Grid.Column>
            <Grid.Column width={6}>
              <span styleName="teal-font">{eventDetails.contact.name}</span><br />
              {eventDetails.contact.field_job_position}
            </Grid.Column>
            <Grid.Column width={7}>
              <div>{eventDetails.contact.field_contact_work}</div>
              <div>{eventDetails.phone || getCommunityPersonPhone(eventDetails.contact)}</div>
            </Grid.Column>
          </Grid.Row>
          )}
          <Grid.Row styleName="no-bottom-padding">
            <Grid.Column width={16}>
              <h4><FormattedMessage {...messages.school} /></h4>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row verticalAlign="middle" styleName="no-top-padding">
            <Grid.Column width={3}>
              <Avatar
                big
                icon="university"
              />
            </Grid.Column>
            <Grid.Column width={13}>
              <span styleName="teal-font">{eventDetails.schoolName}</span>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <h3><FormattedMessage {...messages.collegeFairDetails} /></h3>
        <Grid>
          <Grid.Row>
            <Grid.Column width={8}>
              <h4><FormattedMessage {...messages.date} /></h4>
              <FormattedDate value={`${eventDetails.date}T12:00:00`} {...DATE_FORMAT} />
            </Grid.Column>
            <Grid.Column width={8}>
              <h4><FormattedMessage {...messages.time} /></h4>
              {eventDetails.startTime} - {eventDetails.endTime}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={16}>
              <h4><FormattedMessage {...messages.instructions} /></h4>
              {eventDetails.webInstructions}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

export default CollegeFairDetails;
